import { useSelector, useDispatch } from 'react-redux';
import { set, unSet } from '../store/token/tokenSlice';
import {
  clearOnLocalStorage,
  getFromLocalStorage,
  setOnLocalStorage,
} from '../utils/user-token';
import { useEffect } from 'react';

export const useUserToken = () => {
  const token = useSelector((state) => {
    const _token = state.rootReducer.token.value;
    if (!_token) {
      const _tokenFromStorage = getFromLocalStorage();
      return _tokenFromStorage;
    }
    return _token;
  });
  const dispatch = useDispatch();

  const getUserToken = () => getFromLocalStorage();

  const setUserToken = (token) => {
    if (!token) return;
    dispatch(set(token));
    setOnLocalStorage(token);
  };
  const unSetUserToken = () => {
    dispatch(unSet());
    clearOnLocalStorage();
  };

  useEffect(() => {
    if (!token) {
      const newToken = getUserToken();
      if (newToken) {
        setUserToken(newToken);
      }
    }
  }, [token]);

  return {
    token,
    setUserToken,
    unSetUserToken,
    getUserToken,
  };
};
